import { render, staticRenderFns } from "./BannerGallery.vue?vue&type=template&id=352294c2&scoped=true"
import script from "./BannerGallery.vue?vue&type=script&lang=js"
export * from "./BannerGallery.vue?vue&type=script&lang=js"
import style0 from "./BannerGallery.vue?vue&type=style&index=0&id=352294c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352294c2",
  null
  
)

export default component.exports